module.exports = __webpack_public_path__ + "static/media/custom-02.b096e38b.jpg";